import { MonthsAndYearValues, PVSyst } from "../../../modules/usinas/types";
import { api } from "../api-instance";
const ROUTE = "/PostPvSystData";

export async function postPVSyst(file: File): Promise<PVSyst> {
  const formData = new FormData();
  formData.append("pvSystFile", file);
  const result = await api.post(ROUTE, formData);
  const data = result.data.data[0];
  const pvsyst: PVSyst = {
    ...data,
    e_Grid: convertPVSystMonthsAndYearValuesToMonthandYearValues(data.e_Grid),
    globHor: convertPVSystMonthsAndYearValuesToMonthandYearValues(data.globHor),
    globInc: convertPVSystMonthsAndYearValuesToMonthandYearValues(data.globInc),
    pr: convertPVSystMonthsAndYearValuesToMonthandYearValues(data.pr),
  };
  return pvsyst;
}

export type PVSystMonthsAndYearValues = {
  january?: number | null;
  february?: number | null;
  march?: number | null;
  april?: number | null;
  may?: number | null;
  june?: number | null;
  july?: number | null;
  august?: number | null;
  september?: number | null;
  october?: number | null;
  november?: number | null;
  december?: number | null;
  year?: number;
};

function convertPVSystMonthsAndYearValuesToMonthandYearValues(
  pvsyst: PVSystMonthsAndYearValues
): MonthsAndYearValues {
  return {
    jan: pvsyst.january ?? undefined,
    feb: pvsyst.february ?? undefined,
    mar: pvsyst.march ?? undefined,
    apr: pvsyst.april ?? undefined,
    may: pvsyst.may ?? undefined,
    jun: pvsyst.june ?? undefined,
    jul: pvsyst.july ?? undefined,
    aug: pvsyst.august ?? undefined,
    sep: pvsyst.september ?? undefined,
    oct: pvsyst.october ?? undefined,
    nov: pvsyst.november ?? undefined,
    dec: pvsyst.december ?? undefined,
    year: pvsyst.year ?? undefined,
  };
}
